import axios from '@/jslib/axios'

export const getTrialList = data => {
  return axios({
    method: 'post',
    url: '/admin/trial/list',
    data
  })
}

export const createTrailCode = data => {
  return axios({
    method: 'post',
    url: '/admin/trial/code',
    data
  })
}

export const EditTrailCode = data => {
  return axios({
    method: 'put',
    url: '/admin/trial/code',
    data
  })
}